interface Props {
  children: React.ReactNode;
  className?: string;
}

export const TabDisplayItemWrapper: React.FC<Props> = ({
  children,
  className = "sm:col-span-1",
}) => <div className={className}>{children}</div>;
